import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TipoCambioRequest } from '../models/tipo-cambio-request.model';
import { TipoCambio } from '../models/tipo-cambio.model';
import { TipoCambioImportSunat } from '../models/tipo-cambio-import-sunat.model';
import { TipoCambioResponse } from '../models/tipo-cambio-response.model';
import { urlErp, urlReport } from '../../../../shared/utils/general/url';

const urlTipoCambio = `${urlErp}/tcambio`

@Injectable({
  providedIn: 'root'
})
export class TipoCambioService {

  private http = inject(HttpClient)

  buscar(send?: TipoCambioRequest): Observable<TipoCambio> {

    const params = new HttpParams()
      .set('fechadesde', send ? send.fechadesde : '')
      .set('fechahasta', send ? send.fechahasta : '')
      .set('moneda', send ? send.moneda : '')
      .set('hmoneda', send ? send.hmoneda : '')

    return this.http.get<TipoCambio>(`${urlTipoCambio}/rango`, { params })
  }

  importarSunat(fecha: string): Observable<TipoCambioImportSunat> {
    const params = new HttpParams()
      .set('fecha', fecha ? fecha : '')
    return this.http.get<TipoCambioImportSunat>(`${urlTipoCambio}/importar-tcambio-sunat`, { params })
  }

  guardar(sender: TipoCambioResponse): Observable<any> {
    return this.http.post(`${urlTipoCambio}`, sender)
  }

  actualizar(sender: TipoCambioResponse): Observable<any> {
    return this.http.put(`${urlTipoCambio}`, sender)
  }

  imprimirTipoCambio(periodo: number, mes: number, moneda: string, nombreMoneda: string): Observable<any> {
    const params = new HttpParams()
      .set('periodo', periodo)
      .set('mes', mes)
      .set('moneda', moneda)
      .set('nombreMoneda', nombreMoneda);
    return this.http.get(`${urlReport}/tcambio/pdf`, { params, responseType: 'blob' });
  }
}
